/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DashboardFrontCard from "../../IotComponent/FleetDistanceInsightsCard/DashboardFrontCard";
import {
  Pie,
  PieChart,
  Cell,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Label,
} from "recharts";

import LinearProgress from "@mui/material/LinearProgress";
import "react-datepicker/dist/react-datepicker.css";
import {
  Autocomplete,
  TextField,
} from "@mui/material";
import AppHeader from "../../../../common/Pages/AppHeader/AppHeader";
import RangeDatePicker from "../../IotComponent/AppDatePicker/AppDatePicker";
import { FleetDashboardOverviewApi } from "../../../../API/Iot-Api/FleetDashboardOverview/FleetDashobardOverview";
import {
  HubWiseListResponse,
  IotTypeResponse,
  IotTypeListResponse,
  IotCountResponse,
  CityWiseResponse,
  ClientseResponse,
  BatteryWiseResponse,
  FleetWiseResponse,
  FleetStatusResponse,
  DayWiseStatusResponse,
} from "../../../../@Types/DRO/IotApiResponse/FleetOverviewResponse";
import { useNavigate } from "react-router-dom";

const FleetDistanceInsights = () => {
  const [startDate, setStartDate] = useState<any>();
  const [endDate, setEndDate] = useState<any>();
  const [hubWiseList, setHubWiseList] = useState<HubWiseListResponse | null>(
    null
  );
  const [iotTypesList, setIotTypesList] = useState<string[]>([]);
  const [iotCount, setIotCount] = useState<IotCountResponse | null>(null);
  const [iotTypeValue, setIotTypeValue] = useState<any>();
  const [cityWiseData, setCityWiseData] = useState<CityWiseResponse | null>(null);
  const [clientWiseData, setClientWiseData] = useState<ClientseResponse | null>(null);
  const [batteryWiseRData, setBatteryWiseData] =  useState<BatteryWiseResponse | null>(null);
  const [fleetWiseData, setFleetWiseData] = useState<FleetWiseResponse | null>( null);
  const [fleetStatusData, setFleetStatusData] = useState<FleetStatusResponse | null>(null);
  const [dayWiseData, setDayWiseData] = useState<DayWiseStatusResponse | null>( null);
  const [iotType, setIotType] = useState<IotTypeResponse | null>(null);
  const [selectedDate, setSelectedDate] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() - 2); // Subtract 10 days from the current date
    return date.toISOString().split('T')[0]; 
  });
  
  
  console.log("dateselect", selectedDate);

 const getRandomColor = () => {
  return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
};

const COLORS = Array.from({ length: 7 }, () => getRandomColor()); // Generate 7 random colors


  const loading = false; // Mock loading state

  const handleDateChange = (dates: [Date | null, Date | null]) => {
    setStartDate(dates[0]);
    setEndDate(dates[1]);
  };

  useEffect(() => {
    //const searcValue = `${searchValInput ? `?search=${searchValInput}` : ""}`;

    const fetchIotTypeList = async () => {
      try {
        const data: IotTypeListResponse =
          await FleetDashboardOverviewApi.api.getIotTypeList();

        setIotTypesList(data.data);
      } catch (error) {
        console.error("Error fetching IoT types", error);
      }
    };

    const fetchHubWiseList = async () => {
      try {
        const data: HubWiseListResponse =
          await FleetDashboardOverviewApi.api.getHubWiseList(
            startDate,
            endDate,
            iotTypeValue
          );

        setHubWiseList(data);
      } catch (error) {
        console.error("Error fetchHubWiseList", error);
      }
    };

    const fetchIotType = async () => {
      try {
        const data: IotTypeResponse =
          await FleetDashboardOverviewApi.api.getIotType(
            startDate,
            endDate,
            iotTypeValue
          );

        setIotType(data);
      } catch (error) {
        console.error("Error fetchIotType", error);
      }
    };

    const fetchIotCount = async () => {
      try {
        const data: IotCountResponse =
          await FleetDashboardOverviewApi.api.getIotCount(
            startDate,
            endDate,
            iotTypeValue
          );

        setIotCount(data);
      } catch (error) {
        console.error("Error fetchIotCount", error);
      }
    };
    const fetchCityWiseCount = async () => {
      try {
        const data: CityWiseResponse =
          await FleetDashboardOverviewApi.api.getCityWiseCount(
            startDate,
            endDate,
            iotTypeValue
          );

        setCityWiseData(data);
      } catch (error) {
        console.error("Error fetchCityWiseCount", error);
      }
    };
    const fetchClientWiseCount = async () => {
      try {
        const data: ClientseResponse =
          await FleetDashboardOverviewApi.api.getClientWiseCount(
            startDate,
            endDate,
            iotTypeValue
          );

        setClientWiseData(data);
      } catch (error) {
        console.error("Error fetchClientWiseCount", error);
      }
    };

    const fetchFleetStatusCount = async () => {
      try {
        const data: FleetStatusResponse =
          await FleetDashboardOverviewApi.api.getFleetStatusCount(
            startDate,
            endDate,
            iotTypeValue
          );

        setFleetStatusData(data);
      } catch (error) {
        console.error("Error fetchFleetStatusCount", error);
      }
    };
    const fetchDayWiseCount = async () => {
      try {
        const data: DayWiseStatusResponse =
          await FleetDashboardOverviewApi.api.getDaywiseCount(
            startDate,
            endDate,
            iotTypeValue
          );

        setDayWiseData(data);
      } catch (error) {
        console.error("Error fetchDayWiseCount", error);
      }
    };
    const fetchBatteryWiseCount = async () => {
      try {
        const data: BatteryWiseResponse =
          await FleetDashboardOverviewApi.api.getBatteryWiseCount(selectedDate);

        setBatteryWiseData(data);
      } catch (error) {
        console.error("Error fetchBatteryWiseCount", error);
      }
    };
    const fetchFleetWiseCount = async () => {
      try {
        const data: FleetWiseResponse =
          await FleetDashboardOverviewApi.api.getFleetWiseCount(selectedDate);

        setFleetWiseData(data);
      } catch (error) {
        console.error("Error fetchFleetWiseCount", error);
      }
    };
    fetchDayWiseCount();
    fetchFleetStatusCount();
    fetchFleetWiseCount();
    fetchBatteryWiseCount();
    fetchClientWiseCount();
    fetchCityWiseCount();
    fetchIotType();
    fetchIotCount();
    fetchHubWiseList();
    fetchIotTypeList();
  }, [selectedDate, iotTypeValue, startDate, endDate]);

  const navigate = useNavigate();
  const handleNavigation = (
    countType: string,
    countValue: number,
    hubName: string,
    iotTypeValue: string
  ) => {
    navigate("/reports", {
      state: { tabIndex: 4, countType, countValue, hubName, iotTypeValue },
    });
  };

  const CustomXAxisTick = (props: any) => {
    const { x, y, payload } = props;
    return (
      <g transform={`translate(${x},${y}) rotate(70)`}>
        <text x={0} y={0} dy={5} textAnchor="start" fontSize={8} fill="#666">
          {payload.value}
        </text>
      </g>
    );
  };
  return (
    <>
      <AppHeader />
      <div className="flex justify-evenly bg-[#D8FFEA] px-2  pt-8 pb-4">
        <div className="mb-5 flex">
          <div className="flex items-center ">
            <p className="mr-2 font-semibold">Date Range: </p>
            <RangeDatePicker
              onChange={handleDateChange}
              maxDaysAdd={-2}
              minDaysSub={92}
              defaultStartDate={9}
              defaultEndDate={-2}
            />
          </div>
          <div className="flex items-center w-max bg-white border border-[#ECEEFF]	border-solid rounded-full px-2 py-1 ml-3">
            <div>
              <p className="MuiTypography-root MuiTypography-body1 font-inter text-[#727597] text-sm mr-2 font-normal css-9l3uo3 pl-3">
                IOT Type :{" "}
              </p>
            </div>
            <Autocomplete
              size="small"
              disablePortal
              options={iotTypesList} // Directly use the fetched array
              className="rounded-3xl bg-white"
              sx={{ width: 300 }}
              onChange={(e, value) => {
                setIotTypeValue(value); // Set the selected value
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select IoT Type"
                  InputProps={{
                    ...params.InputProps,
                    sx: {
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none", // Remove border
                      },
                    },
                  }}
                />
              )}
            />
          </div>
        </div>
      </div>

      <div className="bg-slate-100 font-rubik text-sm">
        <div className="flex relative bottom-8">
          <div className="w-3/4	 flex flex-wrap animate__animated animate__fadeInLeft">
            <div className="w-full flex">
              <DashboardFrontCard
                textFirstLine="IOT Connected"
                clientData={iotCount?.data.connected_counts}
                imageURL="/assets/green-iot-icon.svg"
                lineImageURL="/assets/green-line.svg"
                totalData={0}
              ></DashboardFrontCard>

              <DashboardFrontCard
                textFirstLine="IOT Disconnected"
                totalData={0}
                clientData={iotCount?.data.disconnected_counts}
                imageURL="/assets/red-iot-icon.svg"
                lineImageURL="/assets/red-line.svg"
              ></DashboardFrontCard>
              <DashboardFrontCard
                textFirstLine="Grand Total IOTs"
                totalData={0}
                clientData={iotCount?.data.total_counts}
                imageURL="/assets/blue-iot-icon.svg"
                lineImageURL="/assets/blue-line.svg"
              ></DashboardFrontCard>
            </div>

            <div className="flex w-full">
              <div className="flex-grow  w-7/12 rounded-lg bg-[#fff] m-4 shadow px-2">
                <div className="flex justify-between items-center border-b">
                  <h2 className="text-center ml-2 mx-1 mt-2 font-bold text-base text-black pb-2">
                    IOT Disconnections at a glance
                  </h2>
                </div>
                <div className="flex justify-center px-4 py-2">
                  <div className="w-2/5">
                    <table className="w-full border-collapse">
                      <tbody>
                        {dayWiseData?.data.day_wise_bifurcations?.map(
                          (row: any) => (
                            <tr className="border-b">
                              <td className="text-left ml-1 font-semibold text-sm py-2 pl-1">
                                {row.days_bins}
                              </td>
                              <td className="text-[#00CD5B]  font-bold text-sm pb-2">
                                {row.total_counts}
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="w-3/5">
                    <div className="flex flex-col ml-2">
                      <div className="border-2 rounded-lg	text-left	mt-2 border-green-500 p-4">
                        <div className="flex">
                          <div className="border-r-2 border-black-500 pr-4">
                            <p>No Disconnection</p>
                            <h1 className="text-2xl font-bold mt-1">
                              {dayWiseData?.data?.connected_counts}
                            </h1>
                          </div>
                          <div className="pl-4">
                            <p>No Data Available</p>
                            <h1 className="text-2xl font-bold mt-1">
                              {dayWiseData?.data?.no_data_available}
                            </h1>
                          </div>
                        </div>
                      </div>
                      <div className="border-2 rounded-lg	text-left	 border-green-500 p-4 mt-4">
                        <p>Total IOT</p>
                        <h1 className="text-2xl font-bold mt-1">
                          {dayWiseData?.data?.total_iot_counts}
                        </h1>
                      </div>
                    </div>
                  </div>
                  {/* <img src={"/assets/icons/map.svg"} alt="" className="w-9/12" /> */}
                </div>
              </div>
              <div className="flex-grow w-2/6	 rounded-lg bg-[#fff] m-4 shadow">
                <div className="flex justify-between items-center border-b">
                  <h2 className="text-center mx-1 mt-1 font-bold ml-5 text-base text-[#263238] pb-2">
                    IOT Status
                  </h2>
                </div>
                <div className="px-2">
                  <ResponsiveContainer width="100%" height={240}>
                    <PieChart>
                      <Pie
                        data={iotType?.data?.iot_type_wise_counts}
                        cx="50%"
                        cy="50%"
                        //innerRadius="20%"
                        outerRadius="70%"
                        dataKey="value"
                        
                      >
                        {iotType?.data?.iot_type_wise_counts?.map(
                          (_entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS[index % COLORS.length]}
                            />
                          )
                        )}
                      </Pie>
                      <Tooltip />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-grow w-1/4 rounded-lg bg-[#fff] m-4 shadow">
            <div className="flex justify-between items-center border-b px-5">
              <h2 className="text-center mt-2 pb-2 font-bold text-base text-[#263238]">
                Hub wise Mapping for all IOTs
              </h2>
            </div>
            <div
              className="py-1 px-5 h-[330px]"
              style={{ overflowY: "scroll" }}
            >
              {loading ? (
                <LinearProgress
                  sx={{
                    backgroundColor: "white",
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#00CD5B",
                    },
                  }}
                />
              ) : hubWiseList?.data?.hubwise_counts &&
                hubWiseList?.data?.hubwise_counts.length > 0 ? (
                <table className="w-full border-collapse">
                  <tbody>
                    {hubWiseList?.data?.hubwise_counts?.map((riders, index) => (
                      <tr className="border-b" key={index}>
                        <td className="text-left ml-1 font-semibold text-sm pb-2 pl-1">
                          {riders.hub_name}
                        </td>
                        <td
                          className="text-[#00CD5B] font-bold text-sm pb-2 pr-3 cursor-pointer"
                          onClick={() =>
                            handleNavigation(
                              "connected",
                              riders.connected_count,
                              riders.hub_name,
                              iotTypeValue
                            )
                          }
                        >
                          {riders.connected_count}
                        </td>
                        <td
                          className="text-[#FE6151] font-bold text-sm pb-2 cursor-pointer"
                          onClick={() =>
                            handleNavigation(
                              "disconnected",
                              riders.disconnected_count,
                              riders.hub_name,
                              iotTypeValue
                            )
                          }
                        >
                          {riders.disconnected_count}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="font-bold text-[#CE0159] mt-6 mr-6">
                  No Data Found
                </p>
              )}
            </div>
          </div>
        </div>
        {/* { Creating second div elements for card view } */}
        
        <div className="flex">
          <div className="flex-grow w-3/12 rounded-lg bg-[#fff] my-4 mx-3 shadow">
            <div className="flex justify-between items-center border-b">
              <p className="text-center ml-4 mx-1 mt-2 font-bold text-base text-black pb-2">
                Fleet Status Overview for all IOTs
              </p>
            </div>
            {/* <Divider variant="middle" /> */}
            <div
              className="py-1  h-[430px]"
              style={{ overflowY: "scroll" }}
            >
            <div className="px-5 pt-2">
              {loading ? (
                <LinearProgress
                  sx={{
                    backgroundColor: "white",
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#00CD5B",
                    },
                  }}
                />
              ) : fleetStatusData?.data.vehicle_status_wise_bifurcations &&
                fleetStatusData?.data.vehicle_status_wise_bifurcations.length >
                  0 ? (
                <table className="w-full border-collapse">
                  <tbody>
                    {fleetStatusData?.data.vehicle_status_wise_bifurcations?.map(
                      (vehicle: any, index: number) => (
                        <tr key={index} className="border-b">
                          <td className="text-left ml-1 font-semibold text-sm py-2 pl-1">
                            {vehicle.vehicle_status}
                          </td>
                          <td className="text-[#00CD5B]  font-bold text-sm py-2">
                            {vehicle.total_counts}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              ) : (
                <p className="font-bold text-[#CE0159] mt-6 mr-6">
                  No Data Found
                </p>
              )}
            </div>
            </div>
          </div>
          <div className="flex-grow w-4/12 rounded-lg bg-[#fff] m-4 shadow">
            <div className="flex justify-between items-center border-b">
              <h2 className="text-center mx-1 mt-2  font-bold ml-5 text-base text-[#263238] pb-2">
                Client Type Mapping
              </h2>
            </div>
            <div className="py-1 pb-4">
              {clientWiseData?.data.client_wise_bifurcations &&
              clientWiseData?.data.client_wise_bifurcations.length > 0 ? (
                <BarChart
                  width={400}
                  height={400}
                  data={clientWiseData?.data.client_wise_bifurcations}
                  margin={{ left: -10, right: 10, top: -5, bottom: 18 }}
                >
                  <CartesianGrid vertical={false} horizontal={false} />
                  <XAxis
                    dataKey="merchant_name"
                    interval={0}
                    tick={<CustomXAxisTick />}
                  ></XAxis>
                  <YAxis tick={{ fontSize: 10 }} />
                  <Tooltip />
                  <Bar dataKey="total_counts" fill="#ccc">
                    {clientWiseData?.data.client_wise_bifurcations?.map(
                      (entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={entry.merchant_color_code}
                        />
                      )
                    )}
                  </Bar>
                </BarChart>
              ) : (
                <LinearProgress
                  sx={{
                    backgroundColor: "white",
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#00CD5B",
                    },
                  }}
                />
              )}
            </div>
          </div>
          <div className="flex-grow w-5/12 rounded-lg bg-[#fff] m-4 shadow">
            <div className="flex justify-between items-center border-b">
              <h2 className="text-center ml-4 mx-1 mt-2  font-bold text-base text-black pb-2">
                City Mapping
              </h2>
            </div>
            <div className="py-1 pb-4">
              {cityWiseData?.data.city_wise_bifurcations &&
              cityWiseData?.data.city_wise_bifurcations.length > 0 ? (
                <BarChart
                  width={500}
                  height={400}
                  data={cityWiseData.data.city_wise_bifurcations}
                  margin={{ left: -10, right: 10, top: 10, bottom: 8 }}
                >
                  <CartesianGrid vertical={false} horizontal={false} />
                  <XAxis
                    dataKey="city_name"
                    interval={0}
                    tick={{ fontSize: 10 }}
                  >
                    <Label value="City Type ->" fontSize={11} dy={16} />
                  </XAxis>
                  <YAxis tick={{ fontSize: 10 }} />
                  <Tooltip />
                  <Bar dataKey="total_counts" fill="#8884d8" />
                </BarChart>
              ) : (
                <LinearProgress
                  sx={{
                    backgroundColor: "white",
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#00CD5B",
                    },
                  }}
                />
              )}
            </div>
          </div>
        </div>
        <div className="flex">
          <div className="flex-grow w-full rounded-lg bg-[#fff] m-4 shadow">
            <div className="flex justify-between items-center border-b p-3">
              <div>
                <h2 className="text-center ml-4 mx-1 mt-2  font-bold text-base text-black pb-2">
                  Fleet Distance Insights
                </h2>
              </div>
              <div className="flex items-center">
                <div className="mr-3">
                  <TextField
                    name="fdate"
                    id="fdate"
                    //label="Select Date"
                    type="date"
                    value={selectedDate}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      style: { height: "40px", borderRadius: "15px" },
                    }}
                    required
                    //sx={{ mr: 2, width: 300, height: 30, mb: 3 }}
                    onChange={(date) => {
                      setSelectedDate(date.target.value);
                    }}
                  />
                </div>
                
              </div>
            </div>
            <div className="flex">
              <div
                className="flex-grow  rounded-lg bg-[#fff] m-4 shadow"
                style={{ width: "65%" }}
              >
                <div className="flex justify-between items-center border-b">
                  <div>
                    <h2 className="text-center mx-1 mt-2  font-bold ml-5 text-base text-[#263238] pb-2">
                      Fleet Wise Distance Travelled
                    </h2>
                  </div>
                  <div>
                    <h2 className="text-center mr-5 text-base text-[#263238] pb-2">
                      Average Distance Travelled -{" "}
                      {fleetWiseData?.data?.total_dist_travelled
  ? Number(fleetWiseData.data.avg_dist_travelled).toLocaleString("en-IN")
  : "0"}KMs
                    </h2>
                    <h2 className="text-center mr-5 text-base text-[#263238] pb-2">
                      Total Distance Travelled -{" "}
                      {fleetWiseData?.data?.total_dist_travelled
  ? Number(fleetWiseData.data.total_dist_travelled).toLocaleString("en-IN")
  : "0"}KMs
                    </h2>
                  </div>
                </div>
                <div className="py-1 pb-4">
                  {fleetWiseData?.data.fleet_wise_dist &&
                  fleetWiseData?.data.fleet_wise_dist.length > 0 ? (
                    <BarChart
                      width={750}
                      height={350}
                      data={fleetWiseData?.data.fleet_wise_dist}
                      margin={{ left: -10, right: 10, top: -5, bottom: 40 }}
                    >
                      <CartesianGrid vertical={false} horizontal={false} />
                      <XAxis
                        dataKey="fleetname"
                        interval={0}
                        tick={<CustomXAxisTick />}
                      ></XAxis>
                      <YAxis tick={{ fontSize: 10 }} />
                      <Tooltip formatter={(value) => Number(value).toLocaleString("en-IN")}/>

                      <Bar dataKey="totaldist" name="Average Distance">
                        {fleetWiseData?.data.fleet_wise_dist?.map(
                          (entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS[index % COLORS.length]}
                            />
                          )
                        )}
                      </Bar>
                    </BarChart>
                  ) : (
                    <LinearProgress
                      sx={{
                        backgroundColor: "white",
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: "#00CD5B",
                        },
                      }}
                    />
                  )}
                </div>
              </div>

              <div
                className="flex-grow  rounded-lg bg-[#fff] m-4 shadow"
                style={{ width: "32%" }}
              >
                <div className="flex justify-between items-center border-b">
                  <h2 className="text-center ml-4 mx-1 mt-2  font-bold text-base text-black pb-2">
                    Battery Wise Distance Travelled
                  </h2>
                </div>
                <div className="py-1 pb-4">
                  {batteryWiseRData?.data.battery_wise_dist &&
                  batteryWiseRData?.data.battery_wise_dist.length > 0 ? (
                    <BarChart
                      width={400}
                      height={350}
                      data={batteryWiseRData?.data.battery_wise_dist}
                      margin={{ left: -10, right: 10, top: 10, bottom: 8 }}
                    >
                      <CartesianGrid vertical={false} horizontal={false} />
                      <XAxis
                        dataKey="batteryType"
                        interval={0}
                        tick={{ fontSize: 10 }}
                      >
                        <Label
                          value={batteryWiseRData.month}
                          fontSize={11}
                          dy={16}
                        />
                      </XAxis>
                      <YAxis tick={{ fontSize: 10 }} />
                      <Tooltip
  formatter={(value) => Number(value).toLocaleString("en-IN")}
/>

                      <Bar dataKey="totaldist" name="Average Distance">
                        {fleetWiseData?.data.fleet_wise_dist?.map(
                          (entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS[index % COLORS.length]}
                            />
                          )
                        )}
                      </Bar>
                    </BarChart>
                  ) : (
                    <LinearProgress
                      sx={{
                        backgroundColor: "white",
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: "#00CD5B",
                        },
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <h3 className="text-center mb-3">
          © 2025 Powered by Zypp Electric
        </h3>
      </div>
    </>
  );
};

export default FleetDistanceInsights;
